import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

export const ContactList = styled.div`
    flex-direction: column;
`;

export const BlockWrap = styled.div`
    flex-direction: column;
    margin-bottom: 30px;
`;

export const BlockTitle = styled.h2`
    margin-bottom: 20px;
    ${FONTS.H2};
`;

export const BlockList = styled.div`
    flex-direction: column;
`;

export const Elem = styled.div`
    margin-bottom: 20px;
`;

export const ElemIconWrap = styled.div`
    width: 30px;
    padding-top: 3px;
`;

export const ElemIcon = styled.img`
    width: 15px;
    height: 15px;
`;

export const ElemDescription = styled.div`
    flex-direction: column;
    align-items: flex-start;
`;

export const ElemTitle = styled.div`
    margin-bottom: 5px;
    ${FONTS.XS};
    color: ${COLORS.blue};
    border-bottom: 1px dotted;
    cursor: pointer;
`;

export const ElemAddress = styled.div`
    ${FONTS.XS};
`;

export const ElemTime = styled.div`
    ${FONTS.XS};
`;

export const DisplayBtn = styled.button`
    align-self: flex-start;
    width: auto;
    margin-bottom: 5px;
    margin-left: 30px;
    padding: 0;
    ${FONTS.MediumS};
    color: #007AE5;
    border: none;
    border-bottom: 1px dotted;
    background-color: transparent;
    cursor: pointer;

    &:focus {
        outline: none;
    }
`;
